// React Required
import React, { Component } from "react";
import { createRoot } from "react-dom/client";

import "./index.scss";

import PageScrollTop from "./component/PageScrollTop";

import HomePage from "./home/HomePage";

import About from "./elements/About";
import Contact from "./elements/Contact";
import ProjectDetails from "./elements/ProjectDetails";
import News from "./elements/News";
import NewsDetails from "./elements/NewsDetails";
import Publications from "./elements/Publications";
import error404 from "./elements/error404";
import error500 from "./elements/error500";

import Programs from "./elements/Programs";

import Team from "./blocks/Team";
import TeamDetails from "./blocks/team/TeamDetails";
import Project from "./blocks/project/Project";
import Preloader from "./component/Preloader/Preloader";
import { LoadingProvider } from "./LoadingContext";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import "./i18n";

class Root extends Component {
  render() {
    return (
      <LoadingProvider>
        <BrowserRouter basename={"/"}>
          <Preloader />
          <PageScrollTop>
            <Switch>
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/`}
                component={HomePage}
              />

              <Route
                exact
                path={`${process.env.PUBLIC_URL}/home`}
                component={HomePage}
              />

              <Route
                exact
                path={`${process.env.PUBLIC_URL}/educations`}
                component={Programs}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/contact`}
                component={Contact}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/about`}
                component={About}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/projects/:title`}
                component={ProjectDetails}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/news`}
                component={News}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/news/:title`}
                component={NewsDetails}
              />

              <Route
                exact
                path={`${process.env.PUBLIC_URL}/publications`}
                component={Publications}
              />

              <Route
                exact
                path={`${process.env.PUBLIC_URL}/team`}
                component={Team}
              />
              <Route
                exact
                path={`${process.env.PUBLIC_URL}/team/:fullname`}
                component={TeamDetails}
              />
              

              <Route
                exact
                path={`${process.env.PUBLIC_URL}/projects`}
                component={Project}
              />

              <Route
                path={`${process.env.PUBLIC_URL}/404`}
                component={error404}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/500`}
                component={error500}
              />
              <Route component={error404} />
            </Switch>
          </PageScrollTop>
        </BrowserRouter>
      </LoadingProvider>
    );
  }
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Root />);
serviceWorker.register();
